// extracted by mini-css-extract-plugin
export default {"red":"DepthCheck_red__W3CVF","green":"DepthCheck_green__f5pJk","title":"DepthCheck_title__FhTeD"};